export function parseMoneyToMinorUnits(value: string, fractionDigits = 2): number | null {
  const normalized = value.trim();
  const pattern = new RegExp(`^\\d+(?:\\.\\d{0,${fractionDigits}})?$`);
  if (!pattern.test(normalized)) return null;

  const [whole, fraction = ''] = normalized.split('.');
  const paddedFraction = fraction.padEnd(fractionDigits, '0');
  const minorUnits = Number(`${whole}${paddedFraction}`);
  return Number.isSafeInteger(minorUnits) ? minorUnits : null;
}

export function formatMinorUnitsForInput(value: number | undefined, fractionDigits = 2): string {
  if (typeof value !== 'number' || !Number.isInteger(value) || value < 0) return '';
  return (value / 10 ** fractionDigits).toFixed(fractionDigits);
}
